import { PaymentPlans } from '../helpers/Constants';
import Routes from '../helpers/Routes';
import { ICancelSubscriptionParams } from '../models/PaymentModels';
import httpClient from './httpClient';

const {
  pharmacy: { basePath },
  payment: { package: packageRoute, subscriptions, upgrade, transactions },
  general: { cancel, getPDF, invoice, resume }
} = Routes;

class PaymentController {
  getIntentSecret = async (plan: PaymentPlans) => httpClient.get(`${basePath}${packageRoute}/${plan}`);

  cancelSubscription = async (params: ICancelSubscriptionParams) => httpClient.post(`${basePath}${subscriptions}${cancel}`, params);

  resumeSubscription = async () => httpClient.post(`${basePath}${subscriptions}${resume}`)

  upgradePackage = async () => httpClient.post(`${basePath}${packageRoute}${upgrade}`);

  getTransactionsPdf = async () => httpClient.post(`${basePath}${transactions}${getPDF}`)

  getBookingStatus = (bookingId: string) =>
    httpClient.get(
      `${basePath}${Routes.general.bookings}${Routes.general.status}/${bookingId}`
    );

  getInvoiceById = (paymentId: string) => httpClient.get(`${basePath}${invoice}/${paymentId}`)
}

export default new PaymentController();
